import { LEGO_CONSTANTS } from 'constants/index';
import RestService from './restService';

export default class SearchService extends RestService {
  search = (ids = {}, params = {}) => {
    throw new Error(LEGO_CONSTANTS.INVALID_SEARCH_SERVICE);
  };
}
